<template>
    <section class="py-20 lg:py-28">
        <div class="container mx-auto px-4">
            <h2 class="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
                {{ content.title_before }}
                <span v-if="content.title_accent" class="text-gradient-blue">{{ content.title_accent }}</span>
                {{ content.title_after }}
            </h2>
            <p
                v-if="content.subtitle"
                class="text-center text-muted-foreground mb-14 max-w-3xl mx-auto leading-relaxed"
            >
                {{ content.subtitle }}
            </p>

            <div class="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
                <div class="bg-card rounded-xl p-8 border border-border shadow-sm">
                    <h3 v-if="content.checklist_title" class="text-xl font-bold text-foreground mb-5">
                        {{ content.checklist_title }}
                    </h3>
                    <ul class="space-y-3">
                        <li v-for="(item, i) in checklist" :key="i" class="flex items-start gap-3">
                            <div class="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" />
                            <span class="text-muted-foreground">{{ item }}</span>
                        </li>
                    </ul>
                    <p v-if="content.checklist_footnote" class="mt-6 text-accent font-bold text-lg">
                        {{ content.checklist_footnote }}
                    </p>
                </div>

                <div class="space-y-6">
                    <div v-for="(item, i) in features" :key="i" class="flex gap-4">
                        <div class="w-12 h-12 rounded-lg bg-accent/15 flex items-center justify-center flex-shrink-0">
                            <BlockIcon :name="item.icon" class="text-accent" :size="22" />
                        </div>
                        <div>
                            <h4 class="font-bold text-foreground mb-1">{{ item.title }}</h4>
                            <p class="text-sm text-muted-foreground leading-relaxed">{{ item.desc }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";

export default {
    name: "AboutBlock",
    components: { BlockIcon },
    props: { content: { type: Object, default: () => ({}) } },
    computed: {
        checklist() {
            return this.content.checklist || [];
        },
        features() {
            return this.content.features || [];
        },
    },
};
</script>
